<script>
    import { updateGame, deleteGame } from '@/api/games.js';
import constants from '@/constants';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_PAG_GAME_EDIT},
        },
        methods:{
            async save() {
                const data = this.$store.getters.PAG_GAME_EDIT;
                const response = await updateGame(data);
                if (response === true) {
                    this.$store.commit('GAME_UPDATE', {
                        id: data.id,
                        payload: data,
                    });
                    this.$store.commit('PAG_GAME_UPDATE', {
                        providerID: data.provider_id, 
                        gameID: data.id,
                        payload: data,
                    });
                    await this.close();
                }
            },
            async showDeletePopup() {
                this.$store.commit('SHOP_POPUP_NAME', constants.POPUPS_NAME.CONFIRMED);
                this.$store.commit('CONFIRMED_POPUP_METHOD', this.deleteObj.bind(this));
            },

            async deleteObj() {
                const data = this.$store.getters.PAG_GAME_EDIT;
                const response = await deleteGame(data.id);
                if (response === true) {
                    this.$store.commit('GAME_SPLIT', data.id);
                    this.$store.commit('PAG_GAME_SPLIT', {
                        gameID: data.id, 
                        providerID: data.provider_id,
                    });
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PAG_GAME_EDIT', false);
            }
        }
    }
</script>


<template>
    <div>
        <button
            :disabled = "isSave === false"
            class="button_blue_100"
            @click="save"
        >Save</button>
        <button
            class="button_blue_100 button_red ml_10"
            @click="showDeletePopup"
        >Delete</button>
        <button
            class="button_blue_100 close_button mr_10"
            @click="close"
        >Close</button>
    </div>
</template>